

<section class="footer-fix">
    
<div class="marqu-box">
    <div class="news-title"> <p>  notice  <i  class="fa fa-bullhorn mr-2"></i> </p>  </div>
    <marquee  behavior="scroll" scrollamount="5"> {{message}} </marquee>
</div>

    <ul class="nav nav-tabs fixeb-box" id="myTab" role="tablist">
        <li class="nav-item">
            <a class="nav-link bag-1" id="fancy-tab" data-toggle="tab" [routerLink]="['/badla/market',accessToken]">  Live Market </a>
        </li>
        <li class="nav-item">
            <a class="nav-link bag-2" id="line-tab" data-toggle="tab" [routerLink]="['/livebadla',accessToken]">Badla Rate </a>
        </li>
        <li class="nav-item">
            <a class="nav-link bag-3" id="Settlem-ent" data-toggle="tab" [routerLink]="['/badlaorder']"> Manage Badla</a>
        </li>
        <!-- <li class="nav-item">
            <a class="nav-link" id="ball-tab" data-toggle="tab" href="javascript:void(0)">Profile </a>
        </li> -->
     
    </ul>
</section>